import React, { lazy } from 'react';
import { componentsMenu, dashboardMenu, demoPages } from '../menu';
import Login from '../pages/presentation/auth/Login';
import Forgot from '../pages/common/Forgot/forgot';
import Setup from '../pages/presentation/auth/OnboardingSetup';
import Changepw from '../pages/common/Changepw/changepw';
import PAYMENTS from '../common/data/enumPaymentMethod';

// const LANDING = {
// 	DASHBOARD: lazy(() => import('../pages/dashboard/DashboardPage')),
// };

// const SERVICE = {
// 	ADD: lazy(() => import('../pages/presentation/demo-pages/AddServicePage')),
// 	ADDC: lazy(() => import('../pages/presentation/service/AddcCategoryPage')),
// 	ADDP: lazy(() => import('../pages/presentation/service/AddpPromotionPage')),
// 	VIEWS: lazy(() => import('../pages/presentation/demo-pages/ViewsServicePage')),
// };
// const CBOOKING = {
// 	VLIST: lazy(() => import('../pages/presentation/demo-pages/VlistRefundPage')),
// 	PLIST: lazy(() => import('../pages/presentation/demo-pages/PlistRefundPage')),
// };
// const CUSM = {
// 	ALIST: lazy(() => import('../pages/presentation/demo-pages/AlistCusmPage')),
// };
// const VIEWP = {
// 	PRODUCT: lazy(() => import('../pages/presentation/demo-pages/AddProduct')),
// };

// const EMPLOYEEL = {
// 	ADDE: lazy(() => import('../pages/presentation/demo-pages/AddeEmployeelPage')),
// 	EMPSHED: lazy(() => import('../pages/presentation/demo-pages/CommonEmpShed')),
// 	EMPWORKSHED: lazy(() => import('../pages/presentation/demo-pages/WorkerShed')),
// 	EMPLEAVE: lazy(() => import('../pages/presentation/demo-pages/CommonLeave')),
// };

// const VBOOKING = {
// 	VCOMPLETE: lazy(() => import('../pages/presentation/demo-pages/VcompleteVbookingPage')),
// 	VEXPIRED: lazy(() => import('../pages/presentation/demo-pages/VexpiredVbookingPage')),
// 	VUP: lazy(() => import('../pages/presentation/demo-pages/VupVbooking')),
// 	VCANCEL: lazy(() => import('../pages/presentation/demo-pages/VcancelVbooking')),
// 	VASSIGN: lazy(() => import('../pages/presentation/demo-pages/Vassignemp')),
// };

// const SETTING = {
// 	VENDER: lazy(() => import('../pages/presentation/demo-pages/VenderSettingPage')),
// };
// const PACKEGE = {
// 	INVOICE: lazy(() => import('../pages/presentation/demo-pages/PackInvoice')),
// };
// const HELP = {
// 	SUPPORT: lazy(() => import('../pages/presentation/demo-pages/HelpSupport')),
// };
// const BRANCH = {
// 	BLIST: lazy(() => import('../pages/common/CommonBranchlist')),
// };
// // const MANAGES = {
// // 	BIZLIST: lazy(() => import('../pages/presentation/demo-pages/ManageBiz')),
// // 	PACKLIST: lazy(() => import('../pages/presentation/demo-pages/ManagePack')),
// // 	INVLIST: lazy(() => import('../pages/presentation/demo-pages/ManageInv')),
// // };
// const SLIDERSETTING = {
// 	SLIDER: lazy(() => import('../pages/presentation/demo-pages/SliderSettingPage')),
// };

// // const VMAIL = {
// // 	VSEND: lazy(() => import('../pages/presentation/page-layouts/VsendVmailPage')),
// // 	CAMP: lazy(() => import('../pages/presentation/page-layouts/CampVmailPage')),
// // };

// const VTRANCE = {
// 	PAYROLL: lazy(() => import('../pages/common/CommonPayroll')),
// 	INCOME: lazy(() => import('../pages/common/CommonIncomelist')),
// 	EXPENCES: lazy(() => import('../pages/common/CommonExpenceslist')),
// 	CHEQUE: lazy(() => import('../pages/common/CommonChequelist')),
// 	EXTYPE: lazy(() => import('../pages/common/CommonExtypelist')),
// };

// const VREPORT = {
// 	VRGEN: lazy(() => import('../pages/common/CommonReportGen')),
// 	VRSHED: lazy(() => import('../pages/presentation/demo-pages/ReportShed')),
// 	PREFUND: lazy(() => import('../pages/common/CommonReportPrefund')),
// 	CREFUND: lazy(() => import('../pages/common/CommonReportCrefund')),
// 	ORDERS: lazy(() => import('../pages/common/CommonReportOders')),
// 	VRATTD: lazy(() => import('../pages/common/CommonReportAttend')),
// 	PAYMENTS: lazy(() => import('../pages/common/CommonReportPayment')),
// 	COMMISSION: lazy(() => import('../pages/common/CommonCommission')),
// 	VPRO: lazy(() => import('../pages/common/CommonReportPro')),
// };
// const VADMIN = {
// 	VALIST: lazy(() => import('../pages/common/CommonAdminlist')),
// };
// const VROLES = {
// 	VALIST: lazy(() => import('../pages/common/CommonRoleslist')),
// };
// const VSUPER = {
// 	VSMANAGE: lazy(() => import('../pages/presentation/demo-pages/SuperadminSettingPage')),
// };
// const VORDERS = {
// 	ORDERSLIST: lazy(() => import('../pages/common/CommonOrderList')),
// };

// const PRICING = {
// 	PRICING_TABLE: lazy(() => import('../pages/presentation/pricing/PricingTablePage')),
// };

const CONTENT = {
	CONTENTS: lazy(() => import('../pages/documentation/content/ContentListPage')),
	TYPOGRAPHY: lazy(() => import('../pages/documentation/content/TypographyPage')),
	IMAGES: lazy(() => import('../pages/documentation/content/ImagesPage')),
	TABLES: lazy(() => import('../pages/documentation/content/TablesPage')),
	FIGURES: lazy(() => import('../pages/documentation/content/FiguresPage')),
};
const FORMS_PAGE = {
	FORMS: lazy(() => import('../pages/documentation/forms/FormsListPage')),
	FORM_GROUP: lazy(() => import('../pages/documentation/forms/FormGroupPage')),
	FORM_CONTROLS: lazy(() => import('../pages/documentation/forms/FormControlsPage')),
	SELECT: lazy(() => import('../pages/documentation/forms/SelectPage')),
	CHECKS_AND_RADIO: lazy(() => import('../pages/documentation/forms/ChecksAndRadioPage')),
	RANGE: lazy(() => import('../pages/documentation/forms/RangePage')),
	INPUT_GROUP: lazy(() => import('../pages/documentation/forms/InputGroupPage')),
	VALIDATION: lazy(() => import('../pages/documentation/forms/ValidationPage')),
	WIZARD: lazy(() => import('../pages/documentation/forms/WizardPage')),
};
const COMPONENTS_PAGE = {
	COMPONENTS: lazy(() => import('../pages/documentation/components/ComponentsListPage')),
	ACCORDION: lazy(() => import('../pages/documentation/components/AccordionPage')),
	ALERT: lazy(() => import('../pages/documentation/components/AlertPage')),
	BADGE: lazy(() => import('../pages/documentation/components/BadgePage')),
	BREADCRUMB: lazy(() => import('../pages/documentation/components/BreadcrumbPage')),
	BUTTON: lazy(() => import('../pages/documentation/components/ButtonPage')),
	BUTTON_GROUP: lazy(() => import('../pages/documentation/components/ButtonGroupPage')),
	CARD: lazy(() => import('../pages/documentation/components/CardPage')),
	CAROUSEL: lazy(() => import('../pages/documentation/components/CarouselPage')),
	COLLAPSE: lazy(() => import('../pages/documentation/components/CollapsePage')),
	DROPDOWN: lazy(() => import('../pages/documentation/components/DropdownsPage')),
	LIST_GROUP: lazy(() => import('../pages/documentation/components/ListGroupPage')),
	MODAL: lazy(() => import('../pages/documentation/components/ModalPage')),
	NAVS_TABS: lazy(() => import('../pages/documentation/components/NavsTabsPage')),
	OFF_CANVAS: lazy(() => import('../pages/documentation/components/OffCanvasPage')),
	PAGINATION: lazy(() => import('../pages/documentation/components/PaginationPage')),
	POPOVERS: lazy(() => import('../pages/documentation/components/PopoversPage')),
	PROGRESS: lazy(() => import('../pages/documentation/components/ProgressPage')),
	SCROLLSPY: lazy(() => import('../pages/documentation/components/ScrollspyPage')),
	SPINNER: lazy(() => import('../pages/documentation/components/SpinnersPage')),
	TABLE: lazy(() => import('../pages/documentation/components/TablePage')),
	TOASTS: lazy(() => import('../pages/documentation/components/ToastsPage')),
	TOOLTIP: lazy(() => import('../pages/documentation/components/TooltipPage')),
};
const UTILITIES = {
	UTILITIES: lazy(() => import('../pages/documentation/utilities/UtilitiesListPage')),
	API: lazy(() => import('../pages/documentation/utilities/ApiPage')),
	BACKGROUND: lazy(() => import('../pages/documentation/utilities/BackgroundPage')),
	BORDERS: lazy(() => import('../pages/documentation/utilities/BordersPage')),
	COLORS: lazy(() => import('../pages/documentation/utilities/ColorsPage')),
	DISPLAY: lazy(() => import('../pages/documentation/utilities/DisplayPage')),
	FLEX: lazy(() => import('../pages/documentation/utilities/FlexPage')),
	FLOAT: lazy(() => import('../pages/documentation/utilities/FloatPage')),
	INTERACTIONS: lazy(() => import('../pages/documentation/utilities/InteractionsPage')),
	OVERFLOW: lazy(() => import('../pages/documentation/utilities/OverflowPage')),
	POSITION: lazy(() => import('../pages/documentation/utilities/PositionPage')),
	SHADOWS: lazy(() => import('../pages/documentation/utilities/ShadowsPage')),
	SIZING: lazy(() => import('../pages/documentation/utilities/SizingPage')),
	SPACING: lazy(() => import('../pages/documentation/utilities/SpacingPage')),
	TEXT: lazy(() => import('../pages/documentation/utilities/TextPage')),
	VERTICAL_ALIGN: lazy(() => import('../pages/documentation/utilities/VerticalAlignPage')),
	VISIBILITY: lazy(() => import('../pages/documentation/utilities/VisibilityPage')),
};
const ICONS = {
	ICONS_LIST: lazy(() => import('../pages/documentation/icons/IconsListPage')),
	ICON: lazy(() => import('../pages/documentation/icons/IconPage')),
	BOOTSTRAP: lazy(() => import('../pages/documentation/icons/BootstrapIconPage')),
	MATERIAL: lazy(() => import('../pages/documentation/icons/MaterialPage')),
};
const CHARTS_PAGE = {
	CHART_LIST: lazy(() => import('../pages/documentation/charts/ChartsListPage')),
	GENERAL_USAGE: lazy(() => import('../pages/documentation/charts/ChartGeneralUsagePage')),
	SPARKLINE: lazy(() => import('../pages/documentation/charts/ChartSparklinePage')),
	LINE: lazy(() => import('../pages/documentation/charts/ChartLinePage')),
	AREA: lazy(() => import('../pages/documentation/charts/ChartAreaPage')),
	COLUMN: lazy(() => import('../pages/documentation/charts/ChartColumnPage')),
	BAR: lazy(() => import('../pages/documentation/charts/ChartBarPage')),
	MIXED: lazy(() => import('../pages/documentation/charts/ChartMixedPage')),
	TIMELINE: lazy(() => import('../pages/documentation/charts/ChartTimelinePage')),
	CANDLESTICK: lazy(() => import('../pages/documentation/charts/ChartCandlestickPage')),
	BOX_WHISKER: lazy(() => import('../pages/documentation/charts/ChartBoxWhiskerPage')),
	PIE_DONUT: lazy(() => import('../pages/documentation/charts/ChartPieDonutPage')),
	RADAR: lazy(() => import('../pages/documentation/charts/ChartRadarPage')),
	POLAR: lazy(() => import('../pages/documentation/charts/ChartPolarPage')),
	RADIAL_BAR: lazy(() => import('../pages/documentation/charts/ChartRadialBarPage')),
	BUBBLE: lazy(() => import('../pages/documentation/charts/ChartBubblePage')),
	SCATTER: lazy(() => import('../pages/documentation/charts/ChartScatterPage')),
	HEAT_MAP: lazy(() => import('../pages/documentation/charts/ChartHeatMapPage')),
	TREE_MAP: lazy(() => import('../pages/documentation/charts/ChartTreeMapPage')),
};
const EXTRA = {
	NOTIFICATION: lazy(() => import('../pages/documentation/extras/NotificationPage')),
	HOOKS: lazy(() => import('../pages/documentation/extras/HooksPage')),
};

const presentation = [
	/**
	 * Landing
	 */
	// {
	// 	path: dashboardMenu.dashboard.path,
	// 	element: <LANDING.DASHBOARD />,
	// 	exact: true,
	// },
	// // {
	// // 	path: dashboardMenu.dashboardd.path,
	// // 	element: <LANDING.DASHBOARD />,
	// // 	exact: false,
	// // },

	// /** ************************************************** */

	// /**
	//  * Pages
	//  */

	// /**
	//  * Single Pages
	//  */

	// /**
	//  * List
	//  */
	// {
	// 	path: demoPages.servicePages.subMenu.add_serv.path,
	// 	element: <SERVICE.ADD />,
	// 	exact: true,
	// },
	// // {
	// // 	path: demoPages.Manage_mail.subMenu.campaigns.path,
	// // 	element: <VMAIL.CAMP />,
	// // 	exact: true,
	// // },
	// // {
	// // 	path: demoPages.Manage_mail.subMenu.template.path,
	// // 	element: <VMAIL.VSEND />,
	// // 	exact: true,
	// // },
	// {
	// 	path: demoPages.Transaction.subMenu.income.path,
	// 	element: <VTRANCE.INCOME />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.Transaction.subMenu.expences.path,
	// 	element: <VTRANCE.EXPENCES />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.Transaction.subMenu.cheque.path,
	// 	element: <VTRANCE.CHEQUE />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.Transaction.subMenu.extype.path,
	// 	element: <VTRANCE.EXTYPE />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.Transaction.subMenu.manage_pay.path,
	// 	element: <VTRANCE.PAYROLL />,
	// 	exact: true,
	// },

	// {
	// 	path: demoPages.Manage_report.subMenu.appointment.path,
	// 	element: <VREPORT.VRGEN />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.Manage_report.subMenu.product.path,
	// 	element: <VREPORT.VPRO />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.Manage_report.subMenu.sheduler.path,
	// 	element: <VREPORT.VRSHED />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.Manage_report.subMenu.attendance.path,
	// 	element: <VREPORT.VRATTD />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.Manage_report.subMenu.prefund.path,
	// 	element: <VREPORT.PREFUND />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.Manage_report.subMenu.crefund.path,
	// 	element: <VREPORT.CREFUND />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.Manage_report.subMenu.orders.path,
	// 	element: <VREPORT.ORDERS />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.Manage_report.subMenu.payment.path,
	// 	element: <VREPORT.PAYMENTS />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.Manage_report.subMenu.manage_comm.path,
	// 	element: <VREPORT.COMMISSION />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.Manage_v.path,
	// 	element: <VADMIN.VALIST />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.Manage_roles.path,
	// 	element: <VROLES.VALIST />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.Manage_super.path,
	// 	element: <VSUPER.VSMANAGE />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.Orders_v.path,
	// 	element: <VORDERS.ORDERSLIST />,
	// 	exact: true,
	// },

	// {
	// 	path: demoPages.servicePages.subMenu.add_cat.path,
	// 	element: <SERVICE.ADDC />,
	// 	exact: true,
	// },

	// {
	// 	path: demoPages.servicePages.subMenu.add_promo.path,
	// 	element: <SERVICE.ADDP />,
	// 	exact: true,
	// },

	// {
	// 	path: `${demoPages.servicePages.subMenu.view_serv.path}/:id`,
	// 	element: <SERVICE.VIEWS />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.addProduct.path,
	// 	element: <VIEWP.PRODUCT />,
	// 	exact: true,
	// },

	// {
	// 	//path: demoPages.Manage_u.subMenu.all_u.path,
	// 	path: demoPages.Manage_u.path,
	// 	element: <CUSM.ALIST />,
	// 	exact: true,
	// },

	// {
	// 	path: demoPages.Manage_refunds.subMenu.refund_list.path,
	// 	element: <CBOOKING.VLIST />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.Manage_refunds.subMenu.refund_paid.path,
	// 	element: <CBOOKING.PLIST />,
	// 	exact: true,
	// },

	// {
	// 	path: demoPages.Manage_e.subMenu.emp_list.path,
	// 	element: <EMPLOYEEL.ADDE />,
	// 	exact: true,
	// },

	// {
	// 	path: demoPages.Manage_e.subMenu.emp_shed.path,
	// 	element: <EMPLOYEEL.EMPSHED />,
	// 	exact: true,
	// },

	// {
	// 	path: demoPages.Manage_e.subMenu.emp_work_shed.path,
	// 	element: <EMPLOYEEL.EMPWORKSHED />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.Manage_e.subMenu.emp_leave.path,
	// 	element: <EMPLOYEEL.EMPLEAVE />,
	// 	exact: true,
	// },

	// {
	// 	path: demoPages.vbookingPages.subMenu.v_completed_book.path,
	// 	element: <VBOOKING.VCOMPLETE />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.vbookingPages.subMenu.v_expired_book.path,
	// 	element: <VBOOKING.VEXPIRED />,
	// 	exact: true,
	// },

	// {
	// 	path: demoPages.vbookingPages.subMenu.v_book.path,
	// 	element: <VBOOKING.VUP />,
	// 	exact: true,
	// },

	// {
	// 	path: demoPages.vbookingPages.subMenu.v_cancelled_book.path,
	// 	element: <VBOOKING.VCANCEL />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.vbookingPages.subMenu.v_assign_book.path,
	// 	element: <VBOOKING.VASSIGN />,
	// 	exact: true,
	// },

	// /**
	//  * Grid
	//  */

	// /**
	//  * Edit
	//  */
	// {
	// 	path: demoPages.venderSetting.path,
	// 	element: <SETTING.VENDER />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.packegeInvoice.path,
	// 	element: <PACKEGE.INVOICE />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.helpSupport.path,
	// 	element: <HELP.SUPPORT />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.branchList.path,
	// 	element: <BRANCH.BLIST />,
	// 	exact: true,
	// },
	// // {
	// // 	path: demoPages.Manage_sadmin.subMenu.manageBiz.path,
	// // 	element: <MANAGES.BIZLIST />,
	// // 	exact: true,
	// // },
	// // {
	// // 	path: demoPages.Manage_sadmin.subMenu.packages.path,
	// // 	element: <MANAGES.PACKLIST />,
	// // 	exact: true,
	// // },
	// // {
	// // 	path: demoPages.Manage_sadmin.subMenu.manageInv.path,
	// // 	element: <MANAGES.INVLIST />,
	// // 	exact: true,
	// // },
	// {
	// 	path: demoPages.sliderSetting.path,
	// 	element: <SLIDERSETTING.SLIDER />,
	// 	exact: true,
	// },

	// {
	// 	path: demoPages.pricingTable.path,
	// 	element: <PRICING.PRICING_TABLE />,
	// 	exact: true,
	// },

	// /**
	//  * END - Pages
	//  */

	// /**
	//  * Auth Page
	//  */
	// {
	// 	path: demoPages.login.path,
	// 	element: <Login />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.signUp.path,
	// 	element: <Login isSignUp />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.forgot.path,
	// 	element: <Forgot />,
	// 	exact: true,
	// },
	// {
	// 	path: demoPages.changepw.path,
	// 	element: <Changepw />,
	// 	exact: true,
	// },
	{
		path: demoPages.setup.path,
		element: <Setup />,
		exact: true,
	},

	/**
	 * App
	 */

	/**
	 * App > Project Management
	 */

	/**
	 * App > Knowledge
	 */

	/**
	 * App > Sales
	 */

	/**
	 * App > Appointment
	 */

	/**
	 * App > CRM
	 */
	/**
	 * App > Chat
	 */

	/**
	 * END - App
	 */

	/** ************************************************** */

	/**
	 * Page Layout Types
	 */
];
const documentation = [
	/**
	 * Bootstrap
	 */

	/**
	 * Content
	 */
	{
		path: componentsMenu.content.path,
		element: <CONTENT.CONTENTS />,
		exact: true,
	},
	{
		path: componentsMenu.content.subMenu.typography.path,
		element: <CONTENT.TYPOGRAPHY />,
		exact: true,
	},
	{
		path: componentsMenu.content.subMenu.images.path,
		element: <CONTENT.IMAGES />,
		exact: true,
	},
	{
		path: componentsMenu.content.subMenu.tables.path,
		element: <CONTENT.TABLES />,
		exact: true,
	},
	{
		path: componentsMenu.content.subMenu.figures.path,
		element: <CONTENT.FIGURES />,
		exact: true,
	},

	/**
	 * Forms
	 */
	{
		path: componentsMenu.forms.path,
		element: <FORMS_PAGE.FORMS />,
		exact: true,
	},
	{
		path: componentsMenu.forms.subMenu.formGroup.path,
		element: <FORMS_PAGE.FORM_GROUP />,
		exact: true,
	},
	{
		path: componentsMenu.forms.subMenu.formControl.path,
		element: <FORMS_PAGE.FORM_CONTROLS />,
		exact: true,
	},
	{
		path: componentsMenu.forms.subMenu.select.path,
		element: <FORMS_PAGE.SELECT />,
		exact: true,
	},
	{
		path: componentsMenu.forms.subMenu.checksAndRadio.path,
		element: <FORMS_PAGE.CHECKS_AND_RADIO />,
		exact: true,
	},
	{
		path: componentsMenu.forms.subMenu.range.path,
		element: <FORMS_PAGE.RANGE />,
		exact: true,
	},
	{
		path: componentsMenu.forms.subMenu.inputGroup.path,
		element: <FORMS_PAGE.INPUT_GROUP />,
		exact: true,
	},
	{
		path: componentsMenu.forms.subMenu.validation.path,
		element: <FORMS_PAGE.VALIDATION />,
		exact: true,
	},
	{
		path: componentsMenu.forms.subMenu.wizard.path,
		element: <FORMS_PAGE.WIZARD />,
		exact: true,
	},

	/**
	 * Components
	 */
	{
		path: componentsMenu.components.path,
		element: <COMPONENTS_PAGE.COMPONENTS />,
		exact: true,
	},
	{
		path: componentsMenu.components.subMenu.tooltip.path,
		element: <COMPONENTS_PAGE.TOOLTIP />,
		exact: true,
	},
	{
		path: componentsMenu.components.subMenu.toasts.path,
		element: <COMPONENTS_PAGE.TOASTS />,
		exact: true,
	},
	{
		path: componentsMenu.components.subMenu.scrollspy.path,
		element: <COMPONENTS_PAGE.SCROLLSPY />,
		exact: true,
	},
	{
		path: componentsMenu.components.subMenu.carousel.path,
		element: <COMPONENTS_PAGE.CAROUSEL />,
		exact: true,
	},
	{
		path: componentsMenu.components.subMenu.spinners.path,
		element: <COMPONENTS_PAGE.SPINNER />,
		exact: true,
	},
	{
		path: componentsMenu.components.subMenu.listGroup.path,
		element: <COMPONENTS_PAGE.LIST_GROUP />,
		exact: true,
	},
	{
		path: componentsMenu.components.subMenu.breadcrumb.path,
		element: <COMPONENTS_PAGE.BREADCRUMB />,
		exact: true,
	},
	{
		path: componentsMenu.components.subMenu.collapse.path,
		element: <COMPONENTS_PAGE.COLLAPSE />,
		exact: true,
	},
	{
		path: componentsMenu.components.subMenu.pagination.path,
		element: <COMPONENTS_PAGE.PAGINATION />,
		exact: true,
	},
	{
		path: componentsMenu.components.subMenu.progress.path,
		element: <COMPONENTS_PAGE.PROGRESS />,
		exact: true,
	},
	{
		path: componentsMenu.components.subMenu.card.path,
		element: <COMPONENTS_PAGE.CARD />,
		exact: true,
	},
	{
		path: componentsMenu.components.subMenu.button.path,
		element: <COMPONENTS_PAGE.BUTTON />,
		exact: true,
	},
	{
		path: componentsMenu.components.subMenu.buttonGroup.path,
		element: <COMPONENTS_PAGE.BUTTON_GROUP />,
		exact: true,
	},
	{
		path: componentsMenu.components.subMenu.alert.path,
		element: <COMPONENTS_PAGE.ALERT />,
		exact: true,
	},
	{
		path: componentsMenu.components.subMenu.badge.path,
		element: <COMPONENTS_PAGE.BADGE />,
		exact: true,
	},
	{
		path: componentsMenu.components.subMenu.popovers.path,
		element: <COMPONENTS_PAGE.POPOVERS />,
		exact: true,
	},
	{
		path: componentsMenu.components.subMenu.dropdowns.path,
		element: <COMPONENTS_PAGE.DROPDOWN />,
		exact: true,
	},
	{
		path: componentsMenu.components.subMenu.accordion.path,
		element: <COMPONENTS_PAGE.ACCORDION />,
		exact: true,
	},
	{
		path: componentsMenu.components.subMenu.modal.path,
		element: <COMPONENTS_PAGE.MODAL />,
		exact: true,
	},
	{
		path: componentsMenu.components.subMenu.navsTabs.path,
		element: <COMPONENTS_PAGE.NAVS_TABS />,
		exact: true,
	},
	{
		path: componentsMenu.components.subMenu.offcanvas.path,
		element: <COMPONENTS_PAGE.OFF_CANVAS />,
		exact: true,
	},
	{
		path: componentsMenu.components.subMenu.table.path,
		element: <COMPONENTS_PAGE.TABLE />,
		exact: true,
	},

	/**
	 * Utilities
	 */
	{
		path: componentsMenu.utilities.path,
		element: <UTILITIES.UTILITIES />,
		exact: true,
	},
	{
		path: componentsMenu.utilities.subMenu.api.path,
		element: <UTILITIES.API />,
		exact: true,
	},
	{
		path: componentsMenu.utilities.subMenu.background.path,
		element: <UTILITIES.BACKGROUND />,
		exact: true,
	},
	{
		path: componentsMenu.utilities.subMenu.borders.path,
		element: <UTILITIES.BORDERS />,
		exact: true,
	},
	{
		path: componentsMenu.utilities.subMenu.colors.path,
		element: <UTILITIES.COLORS />,
		exact: true,
	},
	{
		path: componentsMenu.utilities.subMenu.display.path,
		element: <UTILITIES.DISPLAY />,
		exact: true,
	},
	{
		path: componentsMenu.utilities.subMenu.flex.path,
		element: <UTILITIES.FLEX />,
		exact: true,
	},
	{
		path: componentsMenu.utilities.subMenu.float.path,
		element: <UTILITIES.FLOAT />,
		exact: true,
	},
	{
		path: componentsMenu.utilities.subMenu.interactions.path,
		element: <UTILITIES.INTERACTIONS />,
		exact: true,
	},
	{
		path: componentsMenu.utilities.subMenu.overflow.path,
		element: <UTILITIES.OVERFLOW />,
		exact: true,
	},
	{
		path: componentsMenu.utilities.subMenu.position.path,
		element: <UTILITIES.POSITION />,
		exact: true,
	},
	{
		path: componentsMenu.utilities.subMenu.shadows.path,
		element: <UTILITIES.SHADOWS />,
		exact: true,
	},
	{
		path: componentsMenu.utilities.subMenu.sizing.path,
		element: <UTILITIES.SIZING />,
		exact: true,
	},
	{
		path: componentsMenu.utilities.subMenu.spacing.path,
		element: <UTILITIES.SPACING />,
		exact: true,
	},
	{
		path: componentsMenu.utilities.subMenu.text.path,
		element: <UTILITIES.TEXT />,
		exact: true,
	},
	{
		path: componentsMenu.utilities.subMenu.verticalAlign.path,
		element: <UTILITIES.VERTICAL_ALIGN />,
		exact: true,
	},
	{
		path: componentsMenu.utilities.subMenu.visibility.path,
		element: <UTILITIES.VISIBILITY />,
		exact: true,
	},

	/**
	 * Extra
	 */

	/**
	 * Icons
	 */
	{
		path: componentsMenu.icons.path,
		element: <ICONS.ICONS_LIST />,
		exact: true,
	},
	{
		path: componentsMenu.icons.subMenu.icon.path,
		element: <ICONS.ICON />,
		exact: true,
	},
	{
		path: componentsMenu.icons.subMenu.material.path,
		element: <ICONS.MATERIAL />,
		exact: true,
	},
	{
		path: componentsMenu.icons.subMenu.bootstrapIcon.path,
		element: <ICONS.BOOTSTRAP />,
		exact: true,
	},

	/**
	 * Charts
	 */
	{
		path: componentsMenu.charts.path,
		element: <CHARTS_PAGE.CHART_LIST />,
		exact: true,
	},
	{
		path: componentsMenu.charts.subMenu.chartsUsage.path,
		element: <CHARTS_PAGE.GENERAL_USAGE />,
		exact: true,
	},
	{
		path: componentsMenu.charts.subMenu.chartsSparkline.path,
		element: <CHARTS_PAGE.SPARKLINE />,
		exact: true,
	},
	{
		path: componentsMenu.charts.subMenu.chartsLine.path,
		element: <CHARTS_PAGE.LINE />,
		exact: true,
	},
	{
		path: componentsMenu.charts.subMenu.chartsArea.path,
		element: <CHARTS_PAGE.AREA />,
		exact: true,
	},
	{
		path: componentsMenu.charts.subMenu.chartsColumn.path,
		element: <CHARTS_PAGE.COLUMN />,
		exact: true,
	},
	{
		path: componentsMenu.charts.subMenu.chartsBar.path,
		element: <CHARTS_PAGE.BAR />,
		exact: true,
	},
	{
		path: componentsMenu.charts.subMenu.chartsMixed.path,
		element: <CHARTS_PAGE.MIXED />,
		exact: true,
	},
	{
		path: componentsMenu.charts.subMenu.chartsTimeline.path,
		element: <CHARTS_PAGE.TIMELINE />,
		exact: true,
	},
	{
		path: componentsMenu.charts.subMenu.chartsCandleStick.path,
		element: <CHARTS_PAGE.CANDLESTICK />,
		exact: true,
	},
	{
		path: componentsMenu.charts.subMenu.chartsBoxWhisker.path,
		element: <CHARTS_PAGE.BOX_WHISKER />,
		exact: true,
	},
	{
		path: componentsMenu.charts.subMenu.chartsPieDonut.path,
		element: <CHARTS_PAGE.PIE_DONUT />,
		exact: true,
	},
	{
		path: componentsMenu.charts.subMenu.chartsRadar.path,
		element: <CHARTS_PAGE.RADAR />,
		exact: true,
	},
	{
		path: componentsMenu.charts.subMenu.chartsPolar.path,
		element: <CHARTS_PAGE.POLAR />,
		exact: true,
	},
	{
		path: componentsMenu.charts.subMenu.chartsRadialBar.path,
		element: <CHARTS_PAGE.RADIAL_BAR />,
		exact: true,
	},
	{
		path: componentsMenu.charts.subMenu.chartsBubble.path,
		element: <CHARTS_PAGE.BUBBLE />,
		exact: true,
	},
	{
		path: componentsMenu.charts.subMenu.chartsScatter.path,
		element: <CHARTS_PAGE.SCATTER />,
		exact: true,
	},
	{
		path: componentsMenu.charts.subMenu.chartsHeatMap.path,
		element: <CHARTS_PAGE.HEAT_MAP />,
		exact: true,
	},
	{
		path: componentsMenu.charts.subMenu.chartsTreeMap.path,
		element: <CHARTS_PAGE.TREE_MAP />,
		exact: true,
	},

	{
		path: componentsMenu.notification.path,
		element: <EXTRA.NOTIFICATION />,
		exact: true,
	},
	{
		path: componentsMenu.hooks.path,
		element: <EXTRA.HOOKS />,
		exact: true,
	},
];
const contents = [...presentation, ...documentation];

export default contents;
